<template>
  <div title="Deployed">
    <div class="full">
      <div class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-2">
        <div class="lefts">
          <a class="" :href="baseUrl" >
        <img  :src="'/imgs/aruvaa_logo.png'" alt="" class="px-3 pt-2 img_size" />
          </a>
          <div class="deploy-img">
          <img :src="'/imgs/deploy1.png'" alt="" class="left-text " />
        </div>
        </div>
        <!-- ... -->
        <div class="lg:col-span-2 grid-cols-1 md:col-span-2 h-auto mt-2 pb-4" style="border: none">
          <!-- right card -->
          <div class="grid grid-cols-5 gap-4">
            <div class="col-span-4 mt-4">
              <!-- progress bar start from here -->
              <progressstep step="2"></progressstep>
              <!-- progress end  -->
              <div class="mt-5 ml-5 pl-3">
                <!-- card start -->

                <div
                  class="rounded my-5 py-3 px-4 shadow-sm"
                  style="background-color: #f4f7ff"
                >
                  <h4 class="font-semibold">Thankyou for your purchase !</h4>
                  <p class="text-lg font-medium">
                    Your subscription for 
                    <span class="font-medium text-green-700">{{ productName }}</span>
                    has been activated.
                  </p>
                  <p class="text-sm text-gray-500">
                    This 
                    <span class="font-medium text-green-700">{{ productName }}</span>
                     has some amazing features.
                  </p>
                  <!-- button -->
                  <div class="d-flex justify-between mt-4">
                    <div class="text-sm mt-2 mb-3">
                      <input type="checkbox" id="checkbox" v-model="checked" />
                      Do you want to Assign License to yourself ?
                    </div>

                    <!-- <a
                      v-bind:href="
                        'https://' +
                        organisationHost +
                        '/tenant-setups/tenantswitch'
                      "
                      class="rounded-md font-bold bg-green-500 text-white px-3 py-1"
                    >
                      Go To {{organisationHost}}&nbsp;
                      <i
                        class="fa fa-long-arrow-right mt-2"
                        aria-hidden="true"
                      ></i>
                    </a> -->
                    <!-- <button
                    @click="deployProductModule()"
                    type="button" class=" rounded-md font-bold bg-green-500 text-white px-3 py-1">
                    Install Now
                    &nbsp;
                    <i class="fa fa-long-arrow-right mt-2" aria-hidden="true"></i>

                  </button> -->
                  </div>
                  <!-- <a
                      v-bind:href="
                        'https://' +
                        organisationHost +
                        '/tenant-setups/tenantswitch'
                      "
                      class="rounded-md font-bold bg-green-500 text-white px-3 py-1 mt-4"
                    >
                      Go To {{organisationHost}}&nbsp;
                      <i
                        class="fa fa-long-arrow-right mt-2"
                        aria-hidden="true"
                      ></i>
                    </a> -->
                  <!-- button end -->

                  <div class="d-flex justify-between ">
                    <div class="text-sm ">
                    
                    </div>

                    <a
                      v-bind:href="orgUrl"
                      class="rounded-md font-semibold bg-green-500 hover:bg-green-600 text-white px-3 py-1"
                    >
                      Go To {{organisationHost}}&nbsp;
                      <i
                        class="fa fa-long-arrow-right mt-2"
                        aria-hidden="true"
                      ></i>
                    </a>
                  </div>
                </div>

                <!-- card end -->
              </div>
            </div>
            <!-- ... -->
            <div></div>
          </div>
          <!--right card end -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Progressstep from "../Views/Components/Progressbar.vue";
import AppLayout from "@/Layouts/AppLayout.vue";
import JetNavLink from "@/Jetstream/NavLink.vue";
import Welcome from "@/Jetstream/Welcome.vue";
import PageTitle from "@/Layouts/PageTitle.vue";

export default {
  props: {
    organisationHost: String,
    subscriptionProductId: String,
    organisationId: String,
    subscriptionPlanId: String,
    subscriptinPriceId: String,
    productName: String,
    subscriptionId: String,
  },

  components: {
    Progressstep,
    AppLayout,
    Welcome,
    PageTitle,
    JetNavLink,
  },
  data() {
    return {
      orgUrl:  this.$utils.goToUrl(this.organisationHost + '/admin/tenant-setups/tenantswitch'),
      checked: true,
      baseUrl: this.$utils.goToUrl(window.env.baseTenantUrl),
    };
  },
  methods: {
    deployProductModule() {
      var data = {
        subscriptionProductId: this.subscriptionProductId,
        organisationHost: this.organisationHost,
        organisationId: this.organisationId,
        subscriptionPlanId: this.subscriptionPlanId,
        subscriptinPriceId: this.subscriptinPriceId,
        subscriptionId: this.subscriptionId,
        assignRole: this.checked,
      };

      this.$inertia.post(route("marketplaces.deployproductmodule"), data);
    },
  },
  mounted() {

    console.log("Deploy OrganisationHost Option", this.organisationHost);
    console.log(this.orgUrl);
  },
};
</script>

<style>
a {
  text-decoration: none !important;
}
/* .select:hover{
  background: #B8E3CF !important;
} */
.left-text {
  margin-top: 6rem;
  /* width: 50% ; */
}
.deploy-img{
  height: 280px;
  width: 280px;
  margin: 2rem auto;
  text-align: center;
}
.full {
  background-color: #ffffff;
  height: 100vh;
  background-size: cover;
  /* overflow: hidden; */
}

p {
  margin-bottom: 0.1rem;
}
h6,
h3,
h2 {
  margin-bottom: 0.03rem;
}

.lefts{
  background-color: #eff3f2;
  height: 100vh;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 0.3rem;
}
input[type="checkbox"] {
  color: #10B981;
}
.img_size {
  height: auto;
  width: 176px;
}

</style>